import styled from 'styled-components'
import { IManualMenu } from '../../../hooks/floating-manual-nav/manual-nav-menu'
import { useContext } from 'react'
import { ThemeContext } from '../../../contexts/ThemeContext'

const FloatingManualContentMenuContainer = styled.div<{ isMenuShown: boolean; isLightTheme: boolean }>`
	position: absolute;
	bottom: 60px;
	width: 100%;
	height: ${(props) => (props.isMenuShown ? '250px' : '0')};
	overflow: hidden;
	box-shadow: ${(props) =>
		props.isLightTheme
			? '-4px 8px 48px rgba(0, 0, 0, 0.1), 8px 0px 100px rgba(0, 0, 0, 0.02)'
			: '-4px 8px 48px rgba(255, 255, 255, 0.1), 8px 0px 100px rgba(255, 255, 255, 0.02)'};
	border-radius: 16px;
	transition: height 0.2s ease-in-out;
`

const FloatingManualContentMenu = styled.div`
	height: 100%;
	background: var(--background-color);
	box-sizing: border-box;

	padding: 20px 20px 40px;
	position: relative;

	& > div.menu--close-icon {
		position: absolute;
		right: 10px;
		top: 10px;
		display: flex;
		justify-content: center;
		align-items: center;
		width: 36px;
		min-height: 36px;
		border-radius: 50px;
		background: var(--floating-menu-close-bg);
		cursor: pointer;
	}

	& > h6 {
		font-size: 18px;
	}

	& > ul {
		margin-top: 15px;
		padding: 0 0 10px;
		list-style: disc;
		padding-left: 20px;
		display: flex;
		flex-direction: column;
		gap: 8px;
		overflow-y: auto;
		max-height: 180px;
	}

	& > ul > li {
		font-family: 'Apercu';
		font-style: normal;
		font-weight: 400;
		font-size: 15px;
		word-break: break-word;
		cursor: pointer;
	}

	& > ul > li:hover {
		color: var(--floating-menu-hover-color);
	}
`

interface ManualMenuProps {
	isMenuShown: boolean
	closeMenu: () => void
	menuContent: IManualMenu[]
}

const ManualMenu = ({ isMenuShown, closeMenu, menuContent }: ManualMenuProps) => {
	const { theme } = useContext(ThemeContext)

	const scrollToTarget = (el: string) => {
		const targetDiv = document.getElementById(el)

		if (targetDiv) {
			targetDiv.scrollIntoView({ behavior: 'smooth' })
		}
	}

	return (
		<FloatingManualContentMenuContainer isMenuShown={isMenuShown} isLightTheme={theme === 'light'}>
			<FloatingManualContentMenu>
				<h6>Manual headers</h6>

				<div className='menu--close-icon' onClick={closeMenu}>
					<svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
						<path d='M15.625 4.375L4.375 15.625' stroke='var(--floating-menu-close-stroke)' strokeLinecap='round' strokeLinejoin='round' />
						<path d='M15.625 15.625L4.375 4.375' stroke='var(--floating-menu-close-stroke)' strokeLinecap='round' strokeLinejoin='round' />
					</svg>
				</div>

				<ul>
					{menuContent &&
						menuContent.map((header) => (
							<li key={header.id} onClick={() => scrollToTarget(header.id)}>
								{header.content}
							</li>
						))}
				</ul>
			</FloatingManualContentMenu>
		</FloatingManualContentMenuContainer>
	)
}

export default ManualMenu
